import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { IAppState } from '../../store/types';
import Avatar from '../avatar/avatar';

interface Props {
    onOpen: () => void;
}

const AvatarMenu: FC<Props> = ({ onOpen }) => {
    const user = useSelector((state: IAppState) => (state.userInfo));
    const { translate } = useLocale();

    return (
        <div id='profileBtnId'>
            <button title={translate.byKey(TranslationKeys.account)} className="flex items-center justify-center statusBarItem" onClick={onOpen}>
                {user.masterImage
                    ? <img className="inline-block h-8 w-8 rounded-full object-cover" src={`data:image/png;base64,${user.masterImage}`} alt="" />
                    : <Avatar />
                }
            </button>
        </div>
    );
};

export default AvatarMenu;
